var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"d-none d-sm-none d-md-block"},[_c('breadcrumb',{attrs:{"items":_vm.breadcrumb}})],1),_vm._v(" "),_c('div',{staticClass:"page-leftheader"},[_c('page-title',{attrs:{"title":_vm.pageTitle}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-211f040a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/page-header.vue
// module id = 715
// module chunks = 0 1 4 5 6 7 8 9 10 11 12 13 14 16 17 18 19 20 22 23 24 25 26 27 28 29 30 31 32 33